// extracted by mini-css-extract-plugin
module.exports = {"imgFluid":"global_imgFluid__vtck9","eventImgFluid":"global_eventImgFluid___Qso1"};